import script from "./SurveyTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyTable.vue?vue&type=script&setup=true&lang=js"

import "./SurveyTable.vue?vue&type=style&index=0&id=d8a8734a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8a8734a"]])

export default __exports__